<!--
选人组件


-->
<template>
  <div>
    <div style="display: flex;flex-wrap: wrap;align-items: center">
      <div v-if="item.name" v-for="(item,index) in user"
           style="display: flex;border:solid 1px #a8cbf9;width: 100px;justify-content: space-around;flex-wrap: wrap;border-radius: 2px;align-items: center;margin: 3px;">
        <div> &nbsp;&nbsp;{{ item.name }}</div>
        <div> &nbsp;&nbsp;<i class="el-icon-close cursor" v-if="!edit" @click="del_user(index)"></i></div>
      </div>
      <div @click="add_users_status=true" class="cursor" style="color: #13ce66" v-if="!edit">
        <i class="el-icon-plus"></i>选择
      </div>
    </div>
    <el-dialog
      top="40px"
      append-to-body
      destroy-on-close
      :visible.sync="add_users_status"
      v-if="add_users_status"
      @close="dialog_close"
    >
      <selectuser @close="close" :mode="mode" @success="success" :list="user"></selectuser>
    </el-dialog>
  </div>
</template>

<script>
import selectuser from "./select_user"

export default {
  props: ["edit", "mode", "values"],
  name: "select_user",
  components: {
    selectuser
  },
  data() {
    return {
      user: [],
      add_users_status: false
    }
  },
  async mounted() {
    setTimeout(() => {
      this.user = this.values
    })
  },
  methods: {

    //设置用户
    async setUserinfo(userList) {
      if (!userList) {
        return
      }
      this.user = userList

    },
    del_user(index) {
      this.user.splice(index, 1);
      this.$emit("select", this.user)
    },
    async dialog_close(e) {

      // this.$emit("select", this.user)
    },
    close() {

      this.$emit("select", this.user)
      this.add_users_status = false
    },
    async success(e) {
      console.log(e)
      this.user = e
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/selectuser.vue